function setCircles() {
  const circleHtml = `
  <svg
     width="30"
     height="30">
    <circle
      class="progress-circle"
      stroke="#00eab6"
      stroke-width="4"
      fill="transparent"
      r="13"
      cx="15"
      cy="15"/>
  </svg>
  <div class="progress-score"></div>
  `;

  var ratingsOnPage = document.querySelectorAll('.okeReviews-starRating');
  for (const rating of ratingsOnPage) {
    const ratingFG = rating.querySelector('.okeReviews-starRating-indicator-layer--foreground');        
    if (!ratingFG) {
      continue;
    }

    const ratingWidth = parseInt(ratingFG.style.width, 10);

    rating.innerHTML = circleHtml;

    const circle = rating.querySelector('circle');
    const radius = circle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;

    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = `${circumference}`;

    const offset = circumference - ratingWidth / 100 * circumference;
    circle.style.strokeDashoffset = offset;

    const score = rating.querySelector('.progress-score');
    score.innerHTML = (Math.round(ratingWidth * 0.5)/10).toString();
  }

}

setCircles();

var poorlyOptimisedObserver = new MutationObserver(setCircles);

poorlyOptimisedObserver.observe(document, { childList: true, subtree: true });
  
var okeReviewsWidgetOnInit =
    okeReviewsCarouselOnInit =
    okeReviewsMediaGridOnInit =
    okeReviewsMediaCarouselOnInit = setCircles;
